import { memo } from "react";
import PropTypes from "prop-types";

// mui
import { Box, Card, CardHeader, Divider } from "@mui/material";
import { DataGrid, GridColumnHeaders, GridRow } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";

// components
import ToolBar from "./ToolBar";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 0,
  "& .MuiDataGrid-withBorderColor": {
    borderColor: theme.palette.grey[200],
  },
  "& .MuiDataGrid-columnHeaders": {
    background: theme.palette.grey[50],
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    borderBottom: "none",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    color: "rgb(47, 55, 70)",
  },
  overflow: "auto", // or 'scroll'
  width: "100%", // or a specific width
}));

const MemoizedRow = memo(GridRow);
const MemoizedColumns = memo(GridColumnHeaders);

const DataTable = ({
  title,
  subheader,
  action,
  columns,
  rows,
  headerSx,
  dataGridSx,
  isColumn,
  isFilter,
  isExport,
  onRowClick,
  getRowId,
}) => (
  <Card>
    <CardHeader
      title={title}
      sx={{ ...headerSx }}
      subheader={subheader}
      action={action}
    />
    <Divider />
    <Box>
      <StyledDataGrid
        autoHeight={false}
        rowHeight={60}
        columns={columns}
        rows={rows}
        slots={{
          row: MemoizedRow,
          columnHeaders: MemoizedColumns,
          toolbar: ToolBar,
        }}
        sx={{ ...dataGridSx }}
        slotProps={{ toolbar: { isColumn, isFilter, isExport } }}
        pageSizeOptions={[5, 10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        onRowClick={onRowClick}
        getRowId={getRowId}
      />
    </Box>
  </Card>
);

DataTable.propTypes = {
  action: PropTypes.node,
  title: PropTypes.string,
  subheader: PropTypes.string,
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  headerSx: PropTypes.object,
  dataGridSx: PropTypes.object,
  isColumn: PropTypes.bool,
  isFilter: PropTypes.bool,
  isExport: PropTypes.bool,
  onRowClick: PropTypes.func,
  getRowId: PropTypes.func,
};

DataTable.defaultProps = {
  rows: [],
  isColumn: true,
  isFilter: true,
  isExport: true,
};

export default DataTable;
